import { createApp } from 'vue'
import Vue from 'vue'
import './axios'
import App from './App.vue'
import router from './router'
import VueExcelXlsx from 'vue-excel-xlsx'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VueGoogleMaps from '@fawmi/vue-google-maps'
// import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";

const app = createApp(App)
app.use(router)
// app.use(BootstrapVue)
// app.use(IconsPlugin)
app.use(VueExcelXlsx)
app.use(VueSweetalert2)
app
  .use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyA7a2uSrMotrUMJqcWGHEH63vyJFAW8u4g'
    }
  })
  .mount('#app')
